import React from "react";
import SearchFilter from "components/searchFilter";
import useTranslation from "utils/hooks/useTranslation";

interface IPropsSearchFilterDocument {
  documentUpdateFilter: (...args) => void;
  documentChangeFieldValue: (...args) => void;
}

const DocumentFilter = ({ documentUpdateFilter, documentChangeFieldValue }: IPropsSearchFilterDocument) => {
  const SEARCH_PLACEHOLDER = `${useTranslation({
    id: "search_document",
  })}...`;

  return <SearchFilter placeholder={SEARCH_PLACEHOLDER} updateFilter={documentUpdateFilter} changeFieldValue={documentChangeFieldValue} numbersTypedCharacters={2} />;
};

export default DocumentFilter;
